module.exports = __webpack_public_path__ + "static/media/clock-blue.a05b76dc.svg";